import { createContext, useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const MenuContext = createContext();

export function MenuProvider({ children }) {
  const [menuType, setMenuType] = useState('operations');
  const navigate = useNavigate();

  const handleMenuTypeChange = (type) => {
    setMenuType(type);
    if (type === 'operations') {
      navigate('/marketplace'); // Default operations tab
    } else {
      navigate('/strategy/dashboard'); // Default strategy tab
    }
  };

  return (
    <MenuContext.Provider value={{ menuType, setMenuType: handleMenuTypeChange }}>
      {children}
    </MenuContext.Provider>
  );
}

export function useMenu() {
  const context = useContext(MenuContext);
  if (!context) {
    throw new Error('useMenu must be used within a MenuProvider');
  }
  return context;
}